import React from "react";

import { Instant } from "@js-joda/core";
import { useGetDashboardEditStatus } from "api/api-hooks/dashboards-hooks";
import UserAvatar from "components/basic/user-avatar/UserAvatar";
import { Message } from "primereact/message";
import useDashboardStore from "store/dashboard-store";

const DashboardEditorWarning: React.FC = () => {
  const firstLoad = React.useRef(true);
  const dashboard = useDashboardStore(state => state.dashboard);
  const { data } = useGetDashboardEditStatus(
    dashboard?.id!,
    dashboard?.modifiedAt ?? Instant.now().toString(),
    firstLoad.current,
    {
      onSuccess: () => {
        firstLoad.current = false;
      },
    }
  );

  if (!data?.message) return null;

  return (
    <Message
      severity={data?.isEdited ? "error" : "warn"}
      text={
        <span className="flex gap-2 align-items-center">
          {data?.message}
          <span>
            {data.otherEditors.map(username => (
              <UserAvatar key={username} username={username} />
            ))}
          </span>
        </span>
      }
    />
  );
};

export default DashboardEditorWarning;
